import React from 'react';
import { Table, Button } from 'react-bootstrap';
import './workflow-reports.scss';
import ReportTable from './components/reportTable/reportTable'

const WorkflowReports = ({ reports }) => {
  // console.log("repors: ", reports)
  const handleApprove = (id) => {
    // console.log('Approving report with ID:', id);
    // Add logic to handle report approval
  };

  const handleReject = (id) => {
    // console.log('Rejecting report with ID:', id);
    // Add logic to handle report rejection
  };

  return (
    <ReportTable reports={reports} />
  );
};

export default WorkflowReports;
